export default __webpack_public_path__ + "static/sailsquare-01857f45216351e9e0a3c22e231a976c.png";